import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { ComputedProductStatus, WarehouseAreaListFilter } from "@/graphql/codegen/graphql"
import { useGetBaseCompanies } from "@/hooks/useGetBaseCompanies"

interface WarehouseCompaniesFilterChipsProps {
  selectedCompanies: string[]
  onRemove: (key: keyof WarehouseAreaListFilter, value: string | ComputedProductStatus) => void
}

const WarehouseCompaniesFilterChips: React.FC<WarehouseCompaniesFilterChipsProps> = ({
  selectedCompanies,
  onRemove,
}) => {
  const { companies } = useGetBaseCompanies({ companyIds: selectedCompanies })

  const companyNames = useMemo(
    () =>
      selectedCompanies.map((id: string) => {
        return companies.find((company) => company.companyId === id)?.name ?? ""
      }) ?? [],
    [selectedCompanies, companies]
  )

  return (
    <>
      {companyNames.map((name, idx) => (
        <FilterChip
          key={`${name}-${idx}`}
          label={`Company: ${name}`}
          onDelete={() => onRemove("companyIds", selectedCompanies![idx])}
          testId={`warehouse-company-filter-chip-${name}`}
        />
      ))}
    </>
  )
}

export default WarehouseCompaniesFilterChips
